import * as saleDetailConstant from './constants'
export const saleDetailReportNvkdRequest = (formData) => {
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_NVKD_REQUESTING,
    formData
  }
}

export const saleDetailReportNvkdSuccess = (data) => {
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_NVKD_SUCCESS,
    data
  }
}

export const saleDetailReportNvkdError = (error) => {
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_NVKD_ERROR,
    error
  }
}
export const saleDetailReportKhRequest = (formData) => {
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_KH_REQUESTING,
    formData
  }
}

export const saleDetailReportKhSuccess = (data) => {
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_KH_SUCCESS,
    data
  }
}

export const saleDetailReportKhError = (error) => {
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_KH_ERROR,
    error
  }
}
export const saleDetailReportKhoXuatRequest = (formData) =>{
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_KHOXUAT_REQUESTING,
    payload: formData
  }
}

export const saleDetailReportKhoXuatSuccess = (data) => {
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_KHOXUAT_SUCCESS,
    data
  }
}

export const saleDetailReportKhoXuatError = (error) => {
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_KHOXUAT_ERROR,
    error
  }
}
export const saleDetailReportListRequest = (formData) => {
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_LIST_REQUESTING,
    formData
  }
}

export const saleDetailReportListSuccess = (data) =>{
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_LIST_SUCCESS,
    data
  }
}

export const saleDetailReportListError = (error) => {
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_LIST_ERROR,
    error
  }
}

export const reportExportXlsRequest = (formData, callback) => {
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_EXPORT_XLS_REQUESTING,
    formData,
    callback
  }
}

export const reportExportXlsSuccess = (data) => {
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_EXPORT_XLS_SUCCESS,
    data
  }
}

export const reportExportXlsError = (error) => {
  return {
    type: saleDetailConstant.SALE_DETAIL_REPORT_EXPORT_XLS_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Reports/SaleDetailReport/actions.js